import COLOR from 'constants/color';
import { ICON_STROKE_WIDTH } from 'constants/icons';
import { IconProps } from 'interfaces';
import { isDarkMode } from 'utils/validators';

interface CalendarDateIconProps extends IconProps {
  /** Day of month shown inside the calendar body. Defaults to the asset's "10". */
  day?: number | string;
}

const CalendarDateIcon = ({
  fill = COLOR.SEMANTIC.INFO_STRONG,
  fillDarkMode = COLOR.WHITE,
  className = '~w-3/5 h-auto',
  strokeWidth = ICON_STROKE_WIDTH.MEDIUM,
  day
}: CalendarDateIconProps) => {
  const fillColor = isDarkMode() ? fillDarkMode : fill;
  const hasCustomDay = day !== undefined && day !== null && day !== '';
  const dayLabel = hasCustomDay ? String(day) : null;

  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      preserveAspectRatio='xMidYMid meet'
      aria-hidden='true'
      className={className}>
      <path
        d='M7 4V2.5'
        stroke={fillColor}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
      />
      <path
        d='M17 4V2.5'
        stroke={fillColor}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
      />
      <path
        d='M21.5 9H16.625H10.75M2 9H5.875'
        stroke={fillColor}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
      />
      <path
        d='M14 22H10C6.22876 22 4.34315 22 3.17157 20.8284C2 19.6569 2 17.7712 2 14V12C2 8.22876 2 6.34315 3.17157 5.17157C4.34315 4 6.22876 4 10 4H14C17.7712 4 19.6569 4 20.8284 5.17157C22 6.34315 22 8.22876 22 12V14C22 17.7712 22 19.6569 20.8284 20.8284C20.1752 21.4816 19.3001 21.7706 18 21.8985'
        stroke={fillColor}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
      />
      {dayLabel ? (
        <text
          x='12'
          y='18'
          textAnchor='middle'
          fill={fillColor}
          className='text-[0.55rem] font-bold'>
          {dayLabel}
        </text>
      ) : (
        <>
          <path
            d='M9 14.5L10.5 13V17'
            stroke={fillColor}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M13 16V14C13 13.4477 13.4477 13 14 13C14.5523 13 15 13.4477 15 14V16C15 16.5523 14.5523 17 14 17C13.4477 17 13 16.5523 13 16Z'
            stroke={fillColor}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
          />
        </>
      )}
    </svg>
  );
};

export default CalendarDateIcon;
